<div class="default-dialog">
    <div class="dialog-header">
        <h3>{{ 'NEXT_STEPS.EMAIL_DIALOG.TITLE.SEND_VIA_MAIL' | translate }}</h3>
        <div class="header-close">
            <button mat-icon-button color="primary" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <form [formGroup]="sendEmailForm">
            <div class="content-mail">
                <div *ngIf="data.mailRecipients.length > 0 && isEmployee()">
                    <div class="default-form-field">
                        <mat-label>{{ 'COMMON.EMAIL_SELECT' | translate }}</mat-label>
                        <mat-form-field appearance="outline">
                            <mat-select id="emailSelect" formControlName="emailSelect" multiple>
                                <mat-option *ngFor="let recipient of data.mailRecipients" [value]="recipient">{{
                                    recipient
                                }}</mat-option>
                            </mat-select>
                            <mat-error>
                                {{ 'NEXT_STEPS.EMAIL_DIALOG.CONTENT.EMAIL_VALIDATION_ERROR_MSG' | translate }}
                            </mat-error>
                        </mat-form-field>
                        <div class="form-field-divider">{{ 'COMMON.OR' | translate }}</div>
                    </div>
                </div>
                <div class="default-form-field">
                    <mat-label>{{ 'COMMON.EMAIL_INPUT' | translate }}</mat-label>
                    <mat-form-field appearance="outline">
                        <input id="email" type="email" formControlName="email" class="email-input" matInput />
                        <mat-error>
                            {{ 'NEXT_STEPS.EMAIL_DIALOG.CONTENT.EMAIL_VALIDATION_ERROR_MSG' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="mail-copy-action" *ngIf="!showMailCopyOptions">
                    <button mat-button color="primary" (click)="toggleMailCopyOptions()">Cc / Bcc hinzufügen</button>
                </div>
                <ng-container *ngIf="showMailCopyOptions">
                    <div class="default-form-field">
                        <mat-label>{{ 'COMMON.EMAIL_CC' | translate }}</mat-label>
                        <div class="form-field-close">
                            <mat-form-field appearance="outline">
                                <input
                                    id="emailCC"
                                    type="email"
                                    formControlName="emailCC"
                                    class="email-input"
                                    matInput
                                />
                                <mat-error>
                                    {{ 'NEXT_STEPS.EMAIL_DIALOG.CONTENT.EMAIL_VALIDATION_ERROR_MSG' | translate }}
                                </mat-error>
                            </mat-form-field>
                            <button mat-icon-button color="primary">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div class="default-form-field">
                        <mat-label>{{ 'COMMON.EMAIL_BCC' | translate }}</mat-label>
                        <div class="form-field-close">
                            <mat-form-field appearance="outline">
                                <input
                                    id="emailBCC"
                                    type="email"
                                    formControlName="emailBCC"
                                    class="email-input"
                                    matInput
                                />
                                <mat-error>
                                    {{ 'NEXT_STEPS.EMAIL_DIALOG.CONTENT.EMAIL_VALIDATION_ERROR_MSG' | translate }}
                                </mat-error>
                            </mat-form-field>
                            <button mat-icon-button color="primary" (click)="toggleMailCopyOptions()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div
                class="content-mailtext pre-filled"
                *ngIf="!sendEmailForm.controls['emailBody'].value && !!data.mailText"
            >
                <div class="mailtext-header">
                    {{ 'COMMON.EMAIL_AUTOMATIC_MESSAGE' | translate }}
                </div>
                <div class="col-10 text-container" [innerHTML]="sanitizedHtml" *ngIf="!!sanitizedHtml"></div>
            </div>
            <div class="default-form-field">
                <mat-label>{{ 'NEXT-STEPS.EMAIL_DIALOG.CONTENT.EMAIL_BODY.PLACEHOLDER' | translate }}</mat-label>
                <mat-form-field appearance="outline">
                    <textarea matInput cdkTextareaAutosize formControlName="emailBody"></textarea>
                </mat-form-field>
            </div>
        </form>
        <div class="content-attachments">
            <div class="attachments-header">
                <h4>{{ 'NEXT-STEPS.EMAIL_DIALOG.CONTENT.ATTACHMENTS.HEADER' | translate }}</h4>
            </div>
            <ul>
                <li>{{ 'NEXT_STEPS.LABEL.QUOTE_PDF' | translate }} PDF</li>
                <li *ngFor="let format of data.selectedExportFormats">{{ format.replace('_', ' ') }}</li>
                <li *ngIf="data.schemes?.length">{{ 'NEXT_STEPS.LABEL.SCHEME' | translate }}</li>
                <li *ngIf="data.schemesDwt?.length">{{ 'NEXT_STEPS.LABEL.SCHEME_DWT' | translate }}</li>
                <li *ngIf="data.energyLabelSelected">
                    {{ 'NEXT_STEPS.LABEL.ENERGY_LABEL' | translate }}
                </li>
            </ul>
            <ul *ngIf="data.offerAttachments.length">
                <li *ngFor="let attachment of data.offerAttachments">
                    {{ attachment.filename }}
                </li>
            </ul>
            <ul *ngIf="data.additionalOfferAttachments.length">
                <li *ngFor="let attachment of data.additionalOfferAttachments">
                    {{ attachment.name }}
                </li>
            </ul>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <ng-container *ngIf="!isLoading">
            <button mat-stroked-button color="primary" [mat-dialog-close]="false">
                {{ 'COMMON.DIALOG.CANCEL' | translate }}
            </button>
            <button
                mat-raised-button
                color="primary"
                [disabled]="isLoading || !sendEmailForm.valid"
                (click)="onYesClick()"
            >
                {{ 'COMMON.DIALOG.SEND' | translate }}
            </button>
        </ng-container>
        <div fxFlex *ngIf="isLoading" fxLayoutAlign="center center">
            <app-loader [message]="'NEXT_STEPS.EMAIL_DIALOG.LOADER.SENDING_DOCUMENTS' | translate"></app-loader>
        </div>
    </mat-dialog-actions>
</div>
